import React from 'react';
import { Box, useColorModeValue } from '@chakra-ui/react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { atomDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
interface CodeBlockProps {
  code: string;
  language?: string;
}
export function CodeBlock({
  code,
  language = 'javascript'
}: CodeBlockProps) {
  const borderColor = useColorModeValue('neonBlue.500', 'neonBlue.400');
  const customStyle = {
    borderRadius: '8px',
    padding: '1em',
    margin: '0',
    backgroundColor: '#1a1a25',
    boxShadow: `0 0 10px rgba(0, 153, 255, 0.3)`,
    border: `1px solid ${borderColor}`
  };
  return <Box borderRadius="md" position="relative" _before={{
    content: '""',
    position: 'absolute',
    top: '-2px',
    left: '-2px',
    right: '-2px',
    bottom: '-2px',
    background: 'linear-gradient(45deg, #0099ff, #7700ff)',
    zIndex: -1,
    borderRadius: 'md',
    opacity: 0.5
  }} data-id="element-92">
      <SyntaxHighlighter language={language} style={atomDark} customStyle={customStyle} data-id="element-93">
        {code}
      </SyntaxHighlighter>
    </Box>;
}